import { z } from 'zod';

import {
  isValidLinkedInProfileUrl,
  LINKEDIN_URL_INVALID_MESSAGE,
  LINKEDIN_URL_MAX_LENGTH,
} from 'helpers/url';

export const objToEnum = <T extends Record<string, unknown>>(obj: T) =>
  Object.values(obj) as [T[keyof T]];

export const dateRangeIntervalSchema = z
  .union([
    z.literal('3mo'),
    z.literal('6mo'),
    z.literal('1yr'),
    z.literal('all'),
  ])
  .optional()
  .default('3mo')
  .catch('3mo');

/** Zod field for LinkedIn profile URLs (empty string allowed). */
export const zLinkedInUrlField = () =>
  z
    .string()
    .max(LINKEDIN_URL_MAX_LENGTH)
    .refine((value) => isValidLinkedInProfileUrl(value), {
      message: LINKEDIN_URL_INVALID_MESSAGE,
    });
